var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgEgg = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 18 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#5c6671",
  d: "M9 0C3.891 0 0 9.997 0 15c0 4.962 4.038 9 9 9s9-4.038 9-9c0-5.003-3.891-15-9-15zm0 23c-4.411 0-8-3.589-8-8C1 10.39 4.703 1 9 1s8 9.39 8 14c0 4.411-3.589 8-8 8zm.5-19.5A.5.5 0 019 4c-1.304 0-5 6.362-5 11a.5.5 0 01-1 0C3 10.402 6.701 3 9 3a.5.5 0 01.5.5z"
})));
export default SvgEgg;